import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [
		{
			name: '活动页',
			path: '/activity',
			component: r => require(['../views/activity'], r)
		},
		{
			name: '登录',
			path: '/login',
			component: r => require(['../views/login'], r)
		},
		{
			name: '应用',
			path: '/',
			redirect: '/home',
			component: r => require(['../views'], r),
			children: [
				{
					name: '首页',
					path: 'home',
					component: r => require(['../views/home'], r)
				},
				{
					name: '帮助中心',
					path: '/help',
					component: r => require(['../views/help'], r)
				},
				{
					name: '菜肴',
					path: 'recipes',
					component: r => require(['../views/recipes'], r)
				},
				{
					name: '',
					path: 'competition',
					component: r => require(['../views/competition'], r)
				},
				{
					name: '我的参赛作品',
					path: 'competition/list',
					component: r => require(['../views/competition/list'], r)
				},
				{
					name: '开始配餐',
					path: 'competition/catering',
					component: r => require(['../views/competition/catering'], r)
				},
				{
					name: '作品评审',
					path: 'review',
					component: r => require(['../views/review'], r)
				},
				{
					name: '评审列表',
					path: 'review/list',
					component: r => require(['../views/review/list'], r)
				},
				{
					name: '修改密码',
					path: 'pwd',
					component: r => require(['../views/pwd'], r)
				},
				{
					name: '邀请',
					path: 'invite',
					component: r => require(['../views/invite'], r)
				}
			]
		}
	]
});



// WEBPACK FOOTER //
// ./src/config/router.js